// project-imports
import { postRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - LOG ERROR ||============================== //

export async function handleLogError(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/log-error', action.data);
    default:
      console.info('[ApiManager > handleApiAction > handleLogError] - Unknown method');
      break;
  }
}
